import { render, staticRenderFns } from "./rest_privat.vue?vue&type=template&id=039450e1&scoped=true&"
import script from "./rest_privat.vue?vue&type=script&lang=js&"
export * from "./rest_privat.vue?vue&type=script&lang=js&"
import style0 from "./rest_privat.vue?vue&type=style&index=0&id=039450e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039450e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('039450e1')) {
      api.createRecord('039450e1', component.options)
    } else {
      api.reload('039450e1', component.options)
    }
    module.hot.accept("./rest_privat.vue?vue&type=template&id=039450e1&scoped=true&", function () {
      api.rerender('039450e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/item/tabs/privat/rest_privat.vue"
export default component.exports